import LinkButton from './LinkButton';

export default LinkButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LinkButton/index.ts